export default __webpack_public_path__ + "static/media/tlm.d384c7dc.png";